export class OverTimeCatIdRequest{
    overTimeCategoryId?: number;

    constructor(overTimeCategoryId: number){
        this.overTimeCategoryId = overTimeCategoryId;
    }
}